import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3798680965/src/front_alegria/node_modules/next/dist/client/app-dir/link.js");
